import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { palette, primaryButtonSx } from './ticketTheme';
import { TICKET_TERMS_SECTIONS } from './ticketTermsContent';

const TicketTermsModal = ({ open, onClose }) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="sm"
    fullWidth
    scroll="paper"
    PaperProps={{
      sx: {
        backgroundColor: palette.surface,
        border: `1px solid ${palette.border}`,
        borderRadius: 3,
        backgroundImage: 'none',
      },
    }}
  >
    <DialogTitle
      sx={{
        color: palette.text,
        fontWeight: 800,
        pr: 6,
        pb: 1,
      }}
    >
      Terms &amp; Conditions
      <IconButton
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: 12,
          top: 12,
          color: palette.textSecondary,
        }}
        aria-label="Close terms"
      >
        <Close />
      </IconButton>
    </DialogTitle>

    <DialogContent dividers sx={{ borderColor: palette.border }}>
      <Typography variant="body2" sx={{ color: palette.textSecondary, mb: 2.5, lineHeight: 1.7 }}>
        Please read these terms before purchasing or using your ticket.
      </Typography>

      {TICKET_TERMS_SECTIONS.map((section) => (
        <Box key={section.title} sx={{ mb: 2 }}>
          <Typography
            variant="subtitle2"
            sx={{ color: palette.accent, fontWeight: 700, mb: 0.5 }}
          >
            {section.title}
          </Typography>
          <Typography variant="body2" sx={{ color: palette.textSecondary, lineHeight: 1.7 }}>
            {section.body}
          </Typography>
        </Box>
      ))}
    </DialogContent>

    <DialogActions sx={{ px: 3, py: 2 }}>
      <Button onClick={onClose} variant="contained" sx={{ ...primaryButtonSx, px: 3 }}>
        Close
      </Button>
    </DialogActions>
  </Dialog>
);

export default TicketTermsModal;
